module.exports = __webpack_public_path__ + "img/Mono Logo(ko)_Dark.4195e4f0.svg";